<template>
  <!-- Stepper -->
  <div class="steps-form-2" v-if="ready">
    <div :class="'steps-row-2 setup-panel-2 d-flex justify-content-between ' + classLine">
      <div
        v-for="(status, key) in status_history"
        v-bind:key="status.id"
        :class="'steps-step-2 ' + status.off"
      >
        <span
          v-if="status.user_client_id"
          id="steps_status"
          :class="
            'btn btn-amber btn-circle-2 waves-effect ml-0 ' +
            status.class_off +
            ' ' +
            status.error
          "
          data-toggle="tooltip"
          data-placement="top"
          v-b-tooltip.hover
          :title="$t('Informado por') | formatTitle($t(status.user_client_id))"
          ><i :class="'fa ' + status.class_fa" aria-hidden="true"></i>
        </span>

        <span
          v-else
          id="steps_status"
          :class="
            'btn btn-amber btn-circle-2 waves-effect ml-0 ' +
            status.class_off +
            ' ' +
            status.error
          "
          data-toggle="tooltip"
          data-placement="top"
          ><i :class="'fa ' + status.class_fa" aria-hidden="true"></i>
        </span>

        <span
          v-if="currentStatusLocal === key"
          :class="'tag ' + status.class_tag"
          :style="status.inline"
        >
          {{ status.status }}
        </span>
        <a
          v-else
          href="#"
          @click.prevent="handleUpdateStatus(status, key)"
          :class="'tag ' + status.class_tag"
          :style="status.inline"
          v-b-tooltip.hover
          :title="$t('Clique para mudar status do pedido para') + ' ' + $t(status.status)"
        >
          {{ status.status }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
export default {
  name: "steps-status",
  props: ["id", "currentStatus"],
  data() {
    return {
      classLine: "inactive one",
      literalNumber: {
        0: "one",
        1: "two",
        2: "three",
        3: "four",
        4: "five",
      },
      status_history: {
        pending: {
          class_tag: "tag-gray",
          status: "Pendente",
          class_off: "inactive",
          off: "off",
          class_fa: "fa-hourglass-half",
        },
        approved: {
          class_tag: "tag-gray",
          status: "Aprovado",
          class_off: "inactive",
          off: "off",
          class_fa: "fa-hourglass-half",
        },
        invoiced: {
          class_tag: "tag-gray",
          status: "Faturado",
          class_off: "inactive",
          off: "off",
          class_fa: "fa-hourglass-half",
        },
        shipping_informed: {
          class_tag: "tag-gray",
          status: "Entrega Informada",
          class_off: "inactive",
          off: "off",
          class_fa: "fa-hourglass-half",
        },
        shipped: {
          class_tag: "tag-gray",
          status: "Enviado",
          class_off: "inactive",
          off: "off",
          class_fa: "fa-hourglass-half",
        },
        delivered: {
          class_tag: "tag-gray",
          status: "Entregue",
          class_off: "inactive",
          off: "off",
          class_fa: "fa-hourglass-half",
        },
      },
      labels: {
        pending: "Pendente",
        approved: "Aprovado",
        partial_payment: "Pagamento parcial",
        shipping_informed: "Entrega informada",
        invoiced: "Faturado",
        invoice_error: "Erro ao gerar nota fiscal",
        shipped: "Enviado",
        shipping_error: "Erro ao enviar entrega",
        delivered: "Entregue",
        canceled: "Cancelado",
      },
      currentStatusLocal:'',
      ready:false
    };
  },
  mounted() {
    this.loadOrder();
    this.currentStatusLocal = this.currentStatus;
    setTimeout(()=> {
      this.ready = true;
    }, 200) 
  },
  filters: {
    formatTitle: function (value, user_client_id) {
      if (value) {
        var self = this;
        if (typeof user_client_id !== "undefined") {
          return value + " " + user_client_id;
        } else {
          return "";
        }
      }
    },
  },
  watch: {
    currentStatus: {
        handler: function(newVal, oldVal) {
          this.currentStatusLocal = newVal
          if (newVal == 'canceled') {
            this.loadOrder();
          }
        },
        immediate: true
    }
  },  
  methods: {
    async handleUpdateStatus(newStatus, key) {
      const sefl = this;
      if (
        this.currentStatusLocal === 'pending'
      ) {
        swal({
              type: "warning",
              title: this.$t("Atenção"),
              text: this.$t("O pedido pendente não pode ter status alterado manualmente."),
            });
        return false;
      } else if (
        this.currentStatusLocal == 'canceled'
      ) {
        swal({
              type: "warning",
              title: this.$t("Atenção"),
              text: this.$t("O pedido não pode ter o status alterado após Cancelado!"),
            });
        return false;
      } else {
        swal({
          title: this.$t("Você tem certeza?"),
          type: "warning",
          text: this.$t(
            "Você está prestes a alterar o status desse pedido para " +
              newStatus.status +
              ", deseja continuar?"
          ),
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Salvar",
        }).then((ok) => {
          if (ok.value) {
            sefl.updateStatusRequest(key);
          }
        });
      }
    },
    updateStatusRequest(newStatus) {
      axios
        .put("/api/orders/" + this.id + "/update_single_order_status/" + newStatus)
        .then((response) => {
          if (!response.data.error) {
            swal({
              type: "success",
              title: this.$t("Sucesso"),
              text: this.$t("O status do pedido foi alterado com sucesso!"),
            });
            this.currentStatusLocal = newStatus;
            this.loadOrder();
          } else {
            swal({
              type: "danger",
              title: this.$t("Erro"),
              text: response.data.message,
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.data && response.data.error) {
            swal({
              type: "error",
              title: this.$t("Erro"),
              text: response.data.message,
            });
          } else {
            swal({
              type: "error",
              title: this.$t("Erro" + "!"),
              text:
                "Não foi possível editar o status do pedido. Por favor, entre em contato com a PluggTo.",
            });
          }
        });
    },
    loadOrder() {
      axios.get("/api/orders/" + this.id + "/logs").then((response) => {
        let situations = response.data.Order.status_history;

        for (let situation in situations) {
          let info = {
            status: this.labels[situations[situation].status],
            user_client_id: situations[situation].user_client_id,
            class_fa: "fa-check",
            class_tag: "tag-green",
          };

          if (
            info.status === "Enviado" ||
            info.status === "Entrega informada" ||
            info.status === "Entregue"
          ) {
            this.status_history["invoiced"] = {
              status: "Faturado",
              user_client_id: "",
              class_fa: "fa-check",
              class_tag: "tag-green",
            };
          }

          if (info.status == "Erro ao enviar entrega") {
            this.status_history["pending"] = {
              status: "Pendente",
              user_client_id: "",
              class_fa: "fa-check",
              class_tag: "tag-green",
            };

            this.status_history["approved"] = {
              status: "Aprovado",
              user_client_id: "",
              class_fa: "fa-check",
              class_tag: "tag-green",
            };

            this.status_history["invoiced"] = {
              status: "Faturado",
              user_client_id: "",
              class_fa: "fa-check",
              class_tag: "tag-green",
            };

            this.status_history["shipping_informed"] = {
              status: this.labels[situations[situation].status],
              user_client_id: situations[situation].user_client_id,
              class_fa: "fa-times",
              class_tag: "tag-red",
              off: "off",
              error: "error",
            };
          } else if (info.status == "Cancelado") {
            this.status_history["approved"] = {
              status: "Cancelado",
              user_client_id: situations[situation].user_client_id,
              class_fa: "fa-times",
              class_tag: "tag-red",
              off: "off",
              error: "error",
            };
          } else {
            this.status_history[situations[situation].status] = info;
          }

          if (info.status == "Aprovado") {
            this.status_history["pending"] = {
              status: "Pendente",
              user_client_id: "",
              class_fa: "fa-check",
              class_tag: "tag-green",
            };
          }

          if (this.status_history["picking"]) {
            delete this.status_history["picking"];
          }
        }
      });
    },
  },
};
</script>

<style>
.steps-form-2 {
  display: table;
  width: 100%;
  margin-top: 25px;
  margin-bottom: 50px;
  position: relative;
}

.steps-form-2 .steps-row-2 {
  display: table-row;
}

.steps-step-2.off::after {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  width: 434%;
  height: 2px;
  background-color: #868e96;
  margin-left: 35px;
}

.steps-form-2 .steps-row-2:before {
  top: 14px;
  bottom: 0;
  position: absolute;
  content: " ";
  height: 2px;
  background-color: #14cc4b;
  width: 1000%;
}

span.btn.btn-amber.btn-circle-2.waves-effect.inactive {
  border: 2px solid #868e96;
  background-color: white !important;
  color: #868e96;
}

.steps-form-2 .steps-row-2 .steps-step-2 {
  display: table-cell;
  text-align: center;
  position: relative;
}

.steps-form-2 .steps-row-2 .steps-step-2 p {
  margin-top: 0.5rem;
}

.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 {
  width: 70px;
  height: 70px;
  border: 2px solid #14cc4b;
  background-color: white !important;
  color: #14cc4b;
  border-radius: 50%;
  padding: 22px 18px 15px 18px;
  margin-top: -22px;
}

.error {
  width: 70px;
  height: 70px;
  border: 2px solid rgb(201, 9, 9) !important;
  background-color: rgb(201, 9, 9) !important;
  color: rgb(201, 9, 9) !important;
  border-radius: 50%;
  padding: 22px 18px 15px 18px;
  margin-top: -22px;
}

.steps-form-2 .steps-row-2 .steps-step-2 .btn-circle-2 .fa {
  font-size: 1.7rem;
}

.steps-form-2 .tag {
  display: block;
  margin-top: 15px;
}

.steps-form-2 .tag:hover {
  text-decoration: none;
}

#steps_status {
  cursor: default !important;
}

.swal2-icon.swal2-warning {
  font-size: inherit !important;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Orders/StepsStatus.vue